<template>
  <div class="reply-container">
    <p class="notification-subtitle paddingBottom ion-no-margin">{{ label }}</p>
    <RichTextBoxV2
      :modelValue="modelValue || ''"
      @update:modelValue="(v) => emit('update:modelValue', v || undefined)"
      placeholder="Enter Text"
      :maxLength="maxLength"
      :showRemainingText="true"
      :showVariableInsertion="false"
      :showCustomField="true"
      :showBotVariable="true"
      :bot_id="botId"
    />
  </div>
</template>

<script setup lang="ts">
// @ts-ignore - .vue SFC with <script setup> lacks explicit default export declaration
import RichTextBoxV2 from '@/components/rich-text-box-v2.vue';

withDefaults(defineProps<{
  modelValue: string | undefined
  label?: string
  maxLength?: number
  botId?: string
}>(), {
  label: 'Enter Custom Text',
  maxLength: 128,
  botId: '',
});

const emit = defineEmits<{
  'update:modelValue': [value: string | undefined]
}>();
</script>

<style scoped>
.reply-container {
  margin-bottom: 15px;
  margin-top: 15px
}
.paddingBottom {
  padding-bottom: 10px;
}
</style>
